import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';

import { useTranslation } from 'react-i18next';

import { CtPrivacyRepository } from 'common/api/models';
import {
  getCurrentPageNumberSelector,
  getSavedVideosFeatureSelector,
  getVideosPerPageSelector,
  userIdSelector,
} from 'common/selectors';
import { pinVideoAction, unpinVideoAction } from 'pages/saved-videos.page';
import { savedVideosSelector } from 'pages/saved-videos.page/selectors';
import { urlSavedVideosSortingSelector } from 'pages/channel.page';
import { Button } from 'components/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbtack } from '@fortawesome/pro-solid-svg-icons';

const mapStateToProps = (state, props) => ({
  savedVideosEnabled: getSavedVideosFeatureSelector(state),
  savedVideos: savedVideosSelector(state),
  userId: userIdSelector(state),
  pageNumber: getCurrentPageNumberSelector(state, props.match),
  sort: urlSavedVideosSortingSelector(state, props.match),
  perPage: getVideosPerPageSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  pinVideo: (payload) => dispatch(pinVideoAction(payload)),
  unpinVideo: (payload) => dispatch(unpinVideoAction(payload)),
});

const PinUnpinVideo = (props) => {
  const { savedVideosEnabled, video, unpinVideo, pinVideo, userId, page, pageNumber, sort, perPage } = props;
  const { t } = useTranslation();

  const enabled = savedVideosEnabled && CtPrivacyRepository.isPrivate();
  const isPined = video.saved;

  const onPinBtnClicked = () => {
    const payload = {
      videoId: video.id,
      userId,
      refreshCollection: page === 'saved-videos',
      pageNumber,
      perPage,
      sort,
    };

    isPined ? unpinVideo(payload) : pinVideo(payload);
  };

  return enabled ? (
    <div data-e2e="pin-unpin">
      <div
        data-tooltip-content={isPined ? t('remove_from_favourites') : t('add_to_favourites')}
        data-tooltip-id="darkTooltip"
        data-delay-show={1000}
      >
        <Button
          icon={true}
          secondary={!isPined}
          aria-label={isPined ? t('remove_from_favourites') : t('add_to_favourites')}
          aria-pressed={isPined}
          onClick={onPinBtnClicked}
        >
          <FontAwesomeIcon icon={faThumbtack} />
        </Button>
      </div>

      <Tooltip
        id="darkTooltip"
        place="top"
        effect="solid"
        type="dark"
        className={'tooltip-restyle'}
        globalEventOff="click"
      />
    </div>
  ) : null;
};

export const PinUnpinVideoDecorated = connect(mapStateToProps, mapDispatchToProps)(PinUnpinVideo);

PinUnpinVideoDecorated.propTypes = {
  video: PropTypes.object.isRequired,
  page: PropTypes.string,
};
